import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App.tsx';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Applications are filled in over weeks in one sitting; refetching on every window
      // focus would fight the form the applicant is typing into.
      refetchOnWindowFocus: false,
      retry: (failureCount, error) =>
        // Never retry an auth or validation failure -- only a genuine network problem.
        failureCount < 2 && !(error instanceof Error && 'status' in error),
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
